<template>
	<div :class="['search', { 'search-focus': isShowInput }]">
		<div class="icon"></div>
		<div class="input">
			<input
				type="text"
				placeholder="请输入搜索内容"
				:class="isShowInput ? 'is-active' : ''"
				v-model="keyWord"
				@keyup.enter="search"
				@focus="handlerInput(1)"
				@blur="handlerInput(2)"
			/>
			<div class="swiper-container search-swiper">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item, index) in searchList" :key="index">
						{{ item }}
					</div>
				</div>
			</div>
		</div>
		<img
			class="clear-icon"
			src="~@/images/new-home/clear-icon.png"
			v-if="keyWord && isShowInput"
			@click="clearSearch(true)"
		/>
		<div class="search-button" @click="search">搜索</div>
	</div>
</template>

<script>
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import { GetGameSearchKeyStore } from '@/service/getData';
export default {
	name: 'search',
	props: {
		gameId: {
			type: Number,
			default: 0
		}
	},
	data() {
		return {
			swiper: '',
			searchList: [],
			keyWord: '',
			index: 0,
			isShowInput: false
		};
	},
	watch: {
		gameId() {
			this.keyWord = '';
			this.getGameSearchKey();
		},
		keyWord(newVal, oldVal) {
			if (!newVal) {
				if (this.searchList && this.searchList.length) {
					this.isShowInput = false;
				} else {
					this.isShowInput = true;
				}
			} else {
				this.isShowInput = true;
			}
		},
		$route(to, from) {
			if (to.path == '/') {
				if (this.searchList && this.searchList.length) {
					setTimeout(() => {
						this.initSwiper();
					}, 200);
				}
			}
		}
	},
	created() {},
	mounted() {
		if (this.gameId) {
			this.getGameSearchKey();
		}
	},
	methods: {
		getGameSearchKey() {
			GetGameSearchKeyStore({ gameId: this.gameId }).then((res) => {
				if (res.data.code == '1' && res.data.result && res.data.result.length > 0) {
					let keys = [];
					res.data.result.map((item) => {
						if (item.keyValues && item.keyValues.split(',').length > 0) {
							keys = keys.concat(item.keyValues.split(','));
						}
					});
					this.searchList = keys;
					this.initSwiper();
					return;
				}
				this.isShowInput = true;
			});
		},
		initSwiper() {
			this.swiper && this.swiper.destroy();
			let that = this;
			this.$nextTick(() => {
				this.swiper = new Swiper('.search-swiper', {
					direction: 'vertical',
					loop: true,
					autoplay: true,
					on: {
						slideChange: function() {
							that.index = this.realIndex;
						}
					}
				});
			});
		},
		search() {
			if (this.keyWord) {
				this.$emit('search', this.keyWord);
			} else {
				if (this.isShowInput == true) {
					this.$emit('search');
					return;
				}
				if (this.searchList.length == 0) {
					this.$toast('请输入搜索内容');
					return false;
				}
				let item = this.searchList[this.index];
				this.keyWord = item;
				this.$emit('search', this.keyWord);
			}
		},
		handlerInput(type) {
			// type 1 focus 2 blur
			if (type == 1) {
				this.isShowInput = true;
			} else {
				if (this.searchList.length != 0) {
					if (!this.keyWord) {
						this.isShowInput = false;
					} else {
						this.isShowInput = true;
					}
				} else {
					this.isShowInput = true;
				}
			}
		},
		clearSearch(isSearch) {
			// type 不传只清除输入框 true 清除输入框并触发搜索
			this.keyWord = '';
			if (isSearch) {
				this.$emit('search');
			} else {
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import '../style/common';
.search {
	width: 100%;
	height: 0.68rem;
	background: #ffffff;
	border-radius: 0.36rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border: 0.02rem solid transparent;
	.icon {
		flex-shrink: 0;
		width: 0.62rem;
		height: 100%;
		background: url('~@/images/new-home/search-icon.png') no-repeat center center;
		background-size: 0.24rem 0.26rem;
	}
	.input {
		flex: 1;
		height: 100%;
		position: relative;
		> input,
		.search-swiper {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
		}
		> input {
			z-index: 2;
			height: 100%;
			outline: none;
			border: none;
			font-size: 0.26rem;
			opacity: 0;
			&::placeholder {
				color: #a2a0aa;
			}
		}
		.is-active {
			opacity: 1;
			background: #ffffff;
		}

		.search-swiper {
			z-index: 1;
			height: 0.68rem;
			.swiper-wrapper {
				width: 100%;
				.swiper-slide {
					width: 100%;
					height: 0.68rem;
					line-height: 0.68rem;
					color: #a2a0aa;
					font-size: 0.24rem;
				}
			}
		}
	}
	.clear-icon {
		width: 0.32rem;
		height: 0.32rem;
		position: absolute;
		right: 1.6rem;
		z-index: 2;
	}
	.search-button {
		flex-shrink: 0;
		margin: 0 0.08rem;
		width: 1.08rem;
		height: 0.53rem;
		background: linear-gradient(90deg, #5592fc 0%, #6dcfff 100%);
		border-radius: 0.28rem;
		text-align: center;
		line-height: 0.53rem;
		font-family: SourceHanSansCN, SourceHanSansCN;
		font-weight: 500;
		font-size: 0.26rem;
		color: #ffffff;
	}
}
.search-focus {
	border: 0.02rem solid #508aff;
}
</style>



// WEBPACK FOOTER //
// src/components/search.vue